module.exports = __webpack_public_path__ + "img/5.5c92b4b0.jpg";